"use client";

import { useTranslations } from "next-intl";
import { MegaMenu } from "./MegaMenu";
import { IllustrationVisual } from "./IllustrationVisual";
import { ScopeIllustration } from "./illustrations/ScopeIllustration";
import { SpeedIllustration } from "./illustrations/SpeedIllustration";
import { OwnershipIllustration } from "./illustrations/OwnershipIllustration";

/** The three reasons, each linking into its section of the page. */
const ITEMS = [
  { key: "fixed", href: "#services", Illustration: ScopeIllustration },
  { key: "speed", href: "#process", Illustration: SpeedIllustration },
  { key: "own", href: "#deliverables", Illustration: OwnershipIllustration },
] as const;

/** "Why [company]?" mega menu — the pitch, one illustrated card per reason. */
export function WhyMegaMenu() {
  const t = useTranslations("header");
  return (
    <MegaMenu
      label={t("nav.why")}
      items={ITEMS.map(({ key, href, Illustration }) => ({
        key,
        href,
        visual: (
          <IllustrationVisual>
            <Illustration />
          </IllustrationVisual>
        ),
        title: t(`menu.${key}.title`),
        detail: t(`menu.${key}.detail`),
        cta: t(`menu.${key}.cta`),
      }))}
    />
  );
}
